module.exports = require("next/dist/server/lib/trace/tracer");